import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { createAnnonce } from "../../actions/annonce.action";
import { IoMdSchool } from "react-icons/io";
import { toast, ToastContainer } from "react-toastify";
import PaiementModal from "./AnnoncesInformations";
import { CATEGORIES } from "../categorie.constant";

const FormationForm = ({ utilisateurId }) => {
  const FORMATION_CATEGORIE_ID = CATEGORIES.find(cat => cat.label === "Formation")?.id;

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    titre: "",
    description: "",
    prix: "",
    frequenceLoyer: "",
    secteur: "",
  });

  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    setModalIsOpen(true);
  }, []);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const dataToSend = new FormData();
    dataToSend.append("categorieId", FORMATION_CATEGORIE_ID);
    dataToSend.append("utilisateur", utilisateurId);
    Object.keys(formData).forEach((key) => {
      dataToSend.append(key, formData[key]);
    });

    try {
      const response = await dispatch(createAnnonce(dataToSend));

      if (
        response &&
        typeof response === "object" &&
        Object.keys(response.errors || {}).length > 0
      ) {
        console.log("Erreurs reçues :", response.errors);
        setErrors(response.errors);
      } else {
        setFormData({
          titre: "",
          description: "",
          prix: "",
          frequenceLoyer: "",
          secteur: "",
        });

        setErrors({});
        toast.success(
          "Félicitations, votre annonce a bien été créée ! Elle sera soumise à la validation de l'administrateur."
        );
      }
    } catch (err) {
      console.error("Erreur lors de la soumission du formulaire :", err);
    }
  };

  return (
    <>
      <form className="AnnonceForm" onSubmit={handleSubmit}>
        <IoMdSchool />
        <h2>Créer une annonce pour une formation :</h2>

        {errors.titre && (
          <span className="error">Votre annonce doit avoir un titre</span>
        )}
        <input
          type="text"
          name="titre"
          placeholder="Titre"
          onChange={handleChange}
          value={formData.titre}
        />

        {errors.description && (
          <span className="error">
            Veuillez donner une description pour votre annonce
          </span>
        )}
        <textarea
          name="description"
          placeholder="Description"
          onChange={handleChange}
          value={formData.description}
        />

        <div className="priceDiv">
          <input
            type="number"
            name="prix"
            placeholder="Prix"
            onChange={handleChange}
            value={formData.prix}
          />

          {errors.frequenceLoyer && (
            <span className="error">
              Veuillez renseigner la fréquence de règlement
            </span>
          )}
          <select
            className="frequenceSelect"
            name="frequenceLoyer"
            onChange={handleChange}
            value={formData.frequenceLoyer}
          >
            <option value="">Périodicité</option>
            <option value="Jour">Jour</option>
            <option value="Semaine">Semaine</option>
            <option value="Mois">Mois</option>
          </select>
          <label>FCFA</label>
        </div>

        <select name="secteur" onChange={handleChange} value={formData.secteur}>
          <option value="">Secteur d'activité</option>
          <option value="Agricole">Agricole</option>
          <option value="Automobile">Automobile</option>
          <option value="Construction">Bâtiment</option>
          <option value="Commerce">Commerce</option>
          <option value="Santé">Santé</option>
          <option value="Restauration/Hôtellerie">
            Restauration/Hôtellerie
          </option>
          <option value="Services">Services</option>
          <option value="Coiffeur">Coiffeur</option>
          <option value="Esthétique">Esthétique</option>
          <option value="Autre">Autre</option>
        </select>

        <button className="button" type="submit">
          Créer l'annonce
        </button>

        <span>Prix de l'annonce : 1000 Francs CFA</span>
        <span>Paiement par Orange Money au 07-04-64-27-18</span>
      </form>
      <PaiementModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      />
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
};

export default FormationForm;
